//tslint:disable max-func-body-length
import * as React from 'react';
import { Numberbox } from 'ui';
import { createConversionFactorsId } from 'app/area/codetable/item/codetable-item-helpers';
import { ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { UomConversionProps } from 'app/area/codetable/item/uom-conversion/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { shouldRender } from 'app/area/codetable/item/uom-conversion/helpers';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

interface UomConversionItemProps extends UomConversionProps {
  item: CodeComplexValue<number>;
}

export const UomConversionItem = (props: UomConversionItemProps) => {

  const { actionType, item, codeItem: { id } = {},
    readOnlyConfig, locale, validation, translation,
    updateUomConversionFactorItem, resetValidation } = props;

  const fieldId = createConversionFactorsId(ScreenField.factor, item?.value);
  const itemValidation = !!validation && validation[fieldId];
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const onChange = (value: number) => {
    updateUomConversionFactorItem(item?.value, value);
    resetValidation(fieldId);
  };

  return shouldRender(id, item, actionType) && <div className="col-md-6 col-sm-12">
    <Numberbox
      readOnly={readOnly}
      label={{ text: item?.description, required: !readOnly }}
      placeholder={translation.uom_conversion_factor_placeholder}
      value={item?.factor}
      onChange={onChange}
      useThousand=" "
      minValue={-999999999999999.999999999999999}
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      locale={locale}
      validation={itemValidation}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
